import ouiBase from '@goldwasserexchange/oui';
import { arDocHasFileName } from '../../../../shared';
import { useAccountPositionsHistoryTransformApiByHisMvtId } from '../api';

export const useAccountPositionsHistoryArDocHasFileName = () => {
  const hisMvtId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountPositionsHistoryTransformApiByHisMvtId({
    hisMvtId,
    transformFunction: arDocHasFileName,
  });
  return response;
};
